import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ptBrValues from "../../locale/pt-br.json";
import ptPtValues from "../../locale/pt.json";
import enValues from "../../locale/en.json";
import esValues from "../../locale/es.json";
import frValues from "../../locale/fr.json";
import deValues from "../../locale/de.json";
import { parseCookies } from "nookies";

const { preferred_language } = parseCookies();

i18n.use(initReactI18next).init({
  lng: preferred_language || "en",
  fallbackLng: "en",
  resources: {
    ptBr: {
      translation: {
        ...ptBrValues.translation,
      },
    },
    pt: {
      translation: {
        ...ptPtValues.translation,
      },
    },
    en: {
      translation: {
        ...enValues.translation,
      },
    },
    es: {
      translation: {
        ...esValues.translation,
      },
    },
    fr: {
      translation: {
        ...frValues.translation,
      },
    },
    de: {
      translation: {
        ...deValues.translation,
      },
    },
  },
  interpolation: {
    escapeValue: false,
  },
});
